function floatingInputWpcf7() {
	$( ".input-floating .wpcf7-form-control" ).focus(
		function () {
			$( this ).parents( ".input-floating" ).addClass( "is-focused" );
		}
	);

	$( ".input-floating .wpcf7-form-control" ).focusout(
		function () {
			if ( $( this ).val() != "" ) {
				$( this ).parents( ".input-floating" ).addClass( "is-focused" );
			} else {
				$( this ).parents( ".input-floating" ).removeClass( "is-focused" );
			}
		}
	);

	$( ".input-floating .wpcf7-form-control" ).each(
		function () {
			if ( $( this ).val() != "" ) {
				$( this ).parents( ".input-floating" ).addClass( "is-focused" );
			} else {
				$( this ).parents( ".input-floating" ).removeClass( "is-focused" );
			}
		}
	);
}

export { floatingInputWpcf7 }
